import { render, staticRenderFns } from "./chooseGoods.vue?vue&type=template&id=6968f6ee&scoped=true"
import script from "./chooseGoods.vue?vue&type=script&lang=js"
export * from "./chooseGoods.vue?vue&type=script&lang=js"
import style0 from "./chooseGoods.vue?vue&type=style&index=0&id=6968f6ee&prod&scoped=true&lang=css"
import style1 from "./chooseGoods.vue?vue&type=style&index=1&id=6968f6ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6968f6ee",
  null
  
)

export default component.exports